export default __webpack_public_path__ + "static/media/max-vertsanov-Sr5sVt9UG4Q-unsplash.ef63c087.jpg";